module.exports = __webpack_public_path__ + "media/images/beauty/pascaline-d6161f4c86d66d27b37cfd0630a62287.jpg";